<template>
  <div>
    <AuthorsList v-if="project"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AuthorsList from '@/components/coding-admin/authors-list';
export default {
  name: 'ProjectAuthors',
  components: {AuthorsList},
  data: function() {
    return {
    }
  },

  mounted() {
    const projectUid = this.$route.params.project_uid;
    this.$emit('setHeaderPrimaryName', this.project.project_name);
    //this.$emit('setHeaderSecondaryName', 'Tags List');
  },

  computed: {
      ...mapState({
        user: state => state.user.user.data,
        project: state => state.projects.project.data
      }),
  },
};
</script>